// extracted by mini-css-extract-plugin
export default {"container":"background_container__EGeDX"};